// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3GUnM","resendInfoText":"OnGoingPaymentBox_resendInfoText__32Dje"};